import CouponCard from "./couponCard";
import PromotionIcon from "../constants/assests/image/promotionIcon.png";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../reduxStore/store";
import { getMyCoupons } from "../models/myCouponSlice";
import { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa6";
import Header from "../shared/header";
import EmptyData from "../shared/emptyRewards";
import LoadingIndicator from "../shared/loadingIndicator";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useSettings } from "../../hooks/useSettings";

function MyCoupon() {
  const [data, setData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  useEffect(() => {
    fetchCustomerHistory(currentPage);
  }, [currentPage]);

  const fetchCustomerHistory = async (page: number) => {
    setLoading(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("accessToken");
      const shop_domain = localStorage.getItem('shop_domain');
      const response = await fetch(
        `${apiUrl}${shop_domain}/api/v1/customer/coupons?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      setData(result.data.data);
      setTotalPages(result.data.last_page);
    } catch (error) {
      console.error("Error fetching customer history:", error);
    } finally {
      setLoading(false);
    }
  };

  const { settings, getSetting } = useSettings();
  const primaryColor = getSetting('primary_color', process.env.REACT_APP_PRIMARY_COLOR || '#1E3A8A');
  const hoverColor = getSetting('widget_hover_color', process.env.REACT_APP_PRIMARY_COLOR_HOVER || '#2563EB');
  return (
    <div className="flex flex-col w-full h-screen bg-bright-ashe">
      {/* Header */}
      <div className="fixed top-0 z-10">
      <a href="/homePage">
      <Header icon={<KeyboardArrowLeftIcon />} name="My Rewards" />
      </a>
      </div>

      {/* Content */}
      <div className="flex flex-col w-full p-5 mt-12 pb-20 bg-bright-ashe ">
        {loading ? (
          <LoadingIndicator />
        ) : data.length > 0 ? (
          <div className="space-y-4">
            {data.map((coupon) => (
              <CouponCard
                key={coupon.id}
                header={coupon.coupon.title}
                description={coupon.valid_till}
                src={PromotionIcon}
                couponsCode={coupon.coupon_code}
                footerText={coupon.coupon.points}
                currentSate={coupon.is_used}
                is_expired={coupon.is_expiry}
              />
            ))}
          </div>
        ) : (
          
          <EmptyData />
   
        )}
      </div>

      {/* Pagination */}
      <div className="flex justify-center py-3 fixed bottom-0 bg-white w-full border-t border-gray-200">
        <button
          onClick={handlePrevPage}
          disabled={currentPage === 1}
          className="text-slate-600 font-thin px-4"
        >
          <KeyboardArrowLeftIcon />
        </button>
        <span className="text-sm font-semibold pt-1">Page {currentPage}</span>
        <button
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          className="text-slate-600 font-thin px-4"
        >
          <KeyboardArrowRightIcon />
        </button>
      </div>
    </div>
  );
}

export default MyCoupon;
